import { createAsyncThunk } from '@reduxjs/toolkit';
import { TicketServices } from 'Services/axios/Ticket.Service';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTickets = createAsyncThunk(
    'Tickets/fetchTickets',
    async (filters) => {
        try {
            const response = await TicketServices.getAll(filters);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const markAsSolved = createAsyncThunk(
    'Tickets/markAsSolved',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('feedback', data.feedback);

            let response;
            response = await TicketServices.markAsSolved(data.id, formData);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);